import React, { useMemo, useState } from "react";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import AcessRightDropdown from "../../component/users/organization-admin/access-rights/AcessRightDropdown";
import { ActivityHistoryColumns } from "../../data/users/ActivityHistoryList";
import { UserListTableData } from "../../data/users/UsersList";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import DataTable from "react-data-table-component";
import ReactDatePicker from "react-datepicker";
import CommonDropDown from "../../component/common/CommonDropDown";
import { tableHeaderStyles } from "../../styles/ReactSelectStyles";

function UserActivityReport() {
  const { t } = useTranslation();
  const [filterText, setFilterText] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  console.log(startDate, "startDate");

  const handleDateChange = (date: Date | null) => {
    console.log("Selected date:", date); // Check if it's being triggered
    setStartDate(date);
  };

  // Flatten all activity history entries from all users
  const allActivityLogs = UserListTableData.filter(
    (user) =>
      Array.isArray(user.ActivityHistory) && user.ActivityHistory.length > 0
  ).flatMap((user) =>
    user.ActivityHistory!.map((activity) => ({
      id: user.id,
      name: user.name,
      image: user.image,
      organizationname: user.organizationname,
      ...activity,
    }))
  );

  // Filter items based on search text
  const filteredItems = allActivityLogs.filter((item) => {
    const search = filterText.toLowerCase();
    return (
      (item.name && item.name.toLowerCase().includes(search)) ||
      (item.action && item.action.toLowerCase().includes(search))
    );
  });

  // Search Section
  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <div
          id="basic-9_filter"
          className="dataTables_filter d-flex align-items-center"
        >
          <FormGroup className="d-flex flex-column align-items-stretch">
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFilterText(e.target.value)
              }
              type="search"
              value={filterText}
              placeholder={t("Search")}
            />
          </FormGroup>
        </div>
        <div
          id="basic-9_filter"
          className="dataTables_filter d-flex align-items-center ms-2"
        >
          <FormGroup className="d-flex flex-column align-items-stretch">
            <ReactDatePicker
              className="datepicker-here form-control"
              selected={startDate}
              onChange={handleDateChange}
              dateFormat="dd/MM/yyyy"
              isClearable
              placeholderText={t("Date")}
            />
          </FormGroup>
        </div>
        <div className="dataTables_filter d-flex align-items-center mb-3 ms-2">
          <CommonDropDown color="info" />
        </div>
      </>
    );
  }, [filterText, startDate, t]);

  return (
    <div className="page-body">
      <Breadcrumbs
        mainTitle={t("UserActivity")}
        parent={t("Reports")}
        parentLink={`${process.env.PUBLIC_URL}/Reports`}
      />

      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <AcessRightDropdown />
                <div className="list-product">
                  <div className="table-responsive">
                    <DataTable
                      data={filteredItems}
                      columns={ActivityHistoryColumns(t)}
                      striped
                      pagination
                      customStyles={tableHeaderStyles}
                      subHeader
                      subHeaderComponent={subHeaderComponentMemo}
                      pointerOnHover
                      highlightOnHover
                      noDataComponent={
                        <div className="text-center p-4 text-muted">
                          {t("NoActivityhistoryMessage")}
                        </div>
                      }
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default UserActivityReport;
